import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../../../../services/authentication.service';

@Component({
  selector: 'app-cyclist-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CyclistResetPasswordComponent implements OnInit {
  private athleteID = '';
  public password = '';
  public verifyPassword = '';
  public canContinue: boolean = true;
  public settingPassword: boolean = false;
  public error: boolean = false;
  public success: boolean = false;
  public errorMessage: string = '';
  public successMessage: string = '';
  public loadingTheme: boolean = false;

  constructor(
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
  ) {}

  ngOnInit() {
    this.athleteID = this.route.snapshot.paramMap.get('clientID');

    this.route.queryParams.subscribe((params) => {
      if (params['Theme']) {
        this.loadingTheme = true;
        setTimeout(() => {
          this.loadingTheme = false;
        }, 1000);
      }
    });
  }

  setPassword() {
    if (this.password === this.verifyPassword) {
      this.canContinue = true;
      this.error = false;
      this.settingPassword = !this.settingPassword;
      var obj = {
        AthleteID: this.athleteID,
        Password: this.password,
      };
      this.authenticationService
        .resetPasswordByUser(JSON.stringify(obj))
        .subscribe((result) => {
          this.settingPassword = !this.settingPassword;
          this.password = '';
          this.verifyPassword = '';
          this.success = true;
          this.successMessage = 'Your password has been changed.';
        });
    } else {
      this.canContinue = false;
      this.error = true;
      this.errorMessage = 'Passwords do not match';
    }
  }
}
